import { ButtonLink } from '@/components/primitives/Button/Button'

import { HalfHalfBlockFormSection } from './HalfHalfBlockFormSection'

import type { ContentfulActionButton } from '@/lib/contentful-api'
import type { FormType } from '@/types/contentful/formType'

export function HalfHalfBlockAction({ actionButton, form }: { actionButton?: ContentfulActionButton; form?: FormType }) {
  if (form) return <HalfHalfBlockFormSection form={form} />

  if (actionButton?.fields?.url) {
    return (
      <ButtonLink href={actionButton.fields.url} className="h-12 w-fit min-w-[134px]" variant="outline">
        {actionButton.fields?.label}
      </ButtonLink>
    )
  }

  return null
}
